angular.module('eatself').filter('pluralize', function() {
	return function(input, count = 2) {
		if (count > 1 && input && !input.endsWith('s') && !input.endsWith('S')) {
			input = input + 's';
		}
		return input && input.replace('{}',count);
	};
})
